import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DownStackDialogProps {
  open: boolean;
  stackName: string;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Confirms "down" (tear down + remove) — the one destructive, hard-to-undo
 * stack action, so it gets an explicit confirm like DeleteSecretDialog. */
export function DownStackDialog({ open, stackName, isDeleting, onCancel, onConfirm }: DownStackDialogProps) {
  return (
    <Modal open={open} title="Take this stack down" onClose={onCancel}>
      <p>
        Stop and remove every container, network, and volume <strong>{stackName}</strong> created, then delete
        Comebye's record of the deploy? Your original compose file, wherever you keep it, is untouched — this only
        tears down what was deployed from it. This can't be undone.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Taking down…" : "Down"}
        </Button>
      </div>
    </Modal>
  );
}
